const strings = {
  'leaderboard/nav/pill': {
    en: 'Challenge',
    fr: 'Défi no',
  },
  'leaderboard/table/rank': {
    en: 'Rank',
    fr: 'Rang',
  },
  'leaderboard/table/localPos': {
    en: (numOfPlayers) => {
      return `There are ${numOfPlayers} Players Ranked Above You`;
    },
    fr: (numOfPlayers) => {
      return `Il y a ${numOfPlayers} participants devant vous dans le classement`;
    },
  },
  'leaderboard/table/endOfPlayerResults': {
    en: (numOfRemainingPlayers) => {
      return `${numOfRemainingPlayers} Players Ranked Below You`;
    },
    fr: (numOfRemainingPlayers) => {
      return `Il y a ${numOfRemainingPlayers} participants derrière vous dans le classement`;
    },
  },
  'leaderboard/table/localPosPep': {
    en: `Keep making the right picks to rank up!`,
    fr: `Continuez de faire les bons choix pour monter dans le classement!`,
  },
  'leaderboard/table/player': {
    en: 'Player',
    fr: 'Participant',
  },
  'leaderboard/table/correct': {
    en: 'Correct',
    fr: 'Choix gagnants',
  },
  'leaderboard/table/pick': {
    en: 'Pick %',
    fr: '% de choix gagnants',
  },
  'leaderboard/table/streak': {
    en: 'Streak',
    fr: 'Victoires consécutives',
  },
  'leaderboard/error/error-state': {
    en: 'We’re experiencing technical difficulties with displaying prizes and are working on a fix. In the meantime, you can still play for your chance to win.',
    fr: 'Nous éprouvons des difficultés techniques avec l’affichage des prix. Nous corrigeons la situation. En attendant, vous pouvez toujours participer pour courir la chance de gagner un prix.',
  },
  'leaderboard/error/no-completed-days': {
    en: 'This challenge just started! Check back soon to see the leaderboard results.',
    fr: 'Ce défi est commencé! Revenez bientôt pour voir le tableau des résultats.',
  },
  'leaderboard/error/no-users': {
    en: 'No leaderboard results are available yet. Please check back soon.',
    fr: 'Aucun résultat du classement n’est encore disponible. Revenez bientôt.',
  },
  'leaderboard/personal-ranking/rank-change': {
    en: 'Since last game:',
    fr: 'Depuis le dernier match',
  },
  'leaderboard/personal-ranking/caret-tooltip/up': {
    en: 'up',
    fr: 'hausse',
  },
  'leaderboard/personal-ranking/caret-tooltip/down': {
    en: 'down',
    fr: 'baisse',
  },
  'leaderboard/personal-ranking/caret-tooltip/none': {
    en: 'none',
    fr: 'rien',
  },
  'leaderboard/toggle/season': {
    en: 'Regular Season',
    fr: 'Saison régulière',
  },
  'leaderboard/toggle/monthly': {
    en: 'Monthly',
    fr: 'Mensuel',
  },
  'leaderboard/toggle/playoffs': {
    en: 'Playoffs',
    fr: 'Séries éliminatoires',
  },
  'leaderboard/playoffs/coming-soon/title': {
    en: 'Coming soon',
    fr: 'À venir sous peu',
  },
  'leaderboard/playoffs/coming-soon/text': {
    en: 'Regular season in progress. Check back later to see the awesome prizes we give away once the Stanley Cup® Playoffs start!',
    fr: 'Saison régulière en cours. Revenez plus tard pour voir les superbes prix que nous proposerons dès le début des séries éliminatoires de la Coupe Stanley<sup style="font-size: 10px; top: -0.5em">MC</sup>!',
  },
  'leaderboard/playoffs/coming-soon/img/src': {
    en: 'stanley-cup-logo.png',
    fr: 'stanley-cup-logo.png',
  },
  'leaderboard/playoffs/coming-soon/btn1': {
    en: 'Make your picks',
    fr: 'Faites vos choix',
  },
  'leaderboard/playoffs/coming-soon/btn2': {
    en: 'Check your stats',
    fr: 'Vérifiez vos statistiques',
  },
  'leaderboard/banner/season/header': {
    en: 'NHL® 2026/2027 Regular Season Challenge',
    fr: 'Défi de la saison régulière 2026-2027 de la LNH<sup>MD</sup>',
  },
  'leaderboard/banner/season/date': {
    en: 'Oct 7 - Apr 16',
    fr: '7 oct - 16 avril',
  },
  'leaderboard/inProgress/text': {
    en: 'IN PROGRESS',
    fr: 'EN COURS',
  },
  'leaderboard/completed/text': {
    en: 'COMPLETED',
    fr: 'TERMINÉ',
  },
  'leaderboard/banner/season/paragraph': {
    en: 'Put your hockey knowledge to the test for a chance to win a Hyundai TUCSON and more!',
    fr: 'Testez vos connaissances en matière de hockey pour courir la chance de gagner une Hyundai TUCSON, et plus encore!',
  },
  'leaderboard/banner/season/link': {
    en: 'View prize info',
    fr: "Voir l'information sur les prix",
  },
  'leaderboard/banner/monthly/header': {
    en: 'Monthly Challenge',
    fr: 'Défi mensuel',
  },
  'leaderboard/banner/monthly/date': {
    en: [
      'Oct 7 - Oct 31',
      'Nov 1 - Nov 30',
      'Dec 1 - Dec 31',
      'Jan 1 - Jan 31',
      'Feb 1 - Feb 28',
      'Mar 1 - Apr 16',
      'Playoffs', //  Apr. 15 - June 12
    ],
    fr: [
      '7 oct. - 31 oct.',
      '1<sup style="font-size: 0.8em">er</sup> nov. - 30 nov.',
      '1<sup style="font-size: 0.8em">er</sup> déc. - 31 déc.',
      '1<sup style="font-size: 0.8em">er</sup> janv. - 31 janv.',
      '1<sup style="font-size: 0.8em">er</sup> févr. - 28 févr.',
      '1<sup style="font-size: 0.8em">er</sup> mars - 16 avr.',
      'Séries éliminatoires', //  15 avril - 12 juin
    ],
  },
  'leaderboard/banner/monthly/paragraph': {
    en: 'A chance to win prizes from these top brands every month!',
    fr: 'Une chance de gagner des prix de ces grandes marques chaque mois!',
  },
  'leaderboard/banner/playoffs/header': {
    en: 'Stanley Cup® Playoffs Challenge',
    fr: 'Défi des séries éliminatoires de la Coupe Stanley<sup>MC</sup>',
  },
  'leaderboard/banner/playoffs/date': {
    en: 'Apr 18',
    fr: '18 avril',
  },
  'leaderboard/banner/playoffs/paragraph': {
    en: 'Put your playoff knowledge to the test for a chance to win <b>a Grand Prize of $5,000!</b>',
    fr: 'Testez vos connaissances des séries éliminatoires et courez la chance de gagner le grand prix de 5 000 $!',
  },
  'leaderboard/banner/playoffs/link': {
    en: 'View prize info',
    fr: "Voir l'information sur les prix",
  },
  'leaderboard/banner/playoffs/route': {
    en: '/game-info',
    fr: '/game-info',
  },
  'leaderboard/season/season-ended/title': {
    en: 'Congrats to the regular season winners!',
    fr: 'Félicitations aux <br /> gagnants de la saison <br /> régulière!',
  },
  'leaderboard/season/season-ended/text': {
    en: 'Winners of the regular season prizes have been contacted. Didn’t win? You’ve got another shot! Put your playoff knowledge to the test for a chance to win new prizes.',
    fr: 'Nous avons communiqué avec les gagnants des prix de la saison régulière. Vous n’avez pas gagné? Voilà votre seconde chance! Testez vos connaissances des séries éliminatoires et courez la chance de gagner de nouveaux prix.',
  },
  'leaderboard/season/season-ended/btn1': {
    en: 'Make your picks',
    fr: 'Faites Vos Choix',
  },
  'leaderboard/season/season-ended/btn2': {
    en: 'Check your stats',
    fr: 'Vérifiez Vos Statistiques',
  },
  'leaderboard/monthly/challenge-ended/title': {
    en: 'Congrats to the Monthly Challenge winners!',
    fr: 'Félicitations aux<br /> gagnants du défi<br /> mensuel!',
  },
  'leaderboard/monthly/challenge-ended/text': {
    en: 'Winners of our last Monthly Challenge prizes have been contacted. Didn’t win? You’ve got another shot! Put your playoff knowledge to the test for a chance to win new prizes.',
    fr: 'Nous avons communiqué avec les gagnants des prix du défi mensuel. Vous n’avez pas gagné? Voilà votre seconde chance! Testez vos connaissances des séries éliminatoires et courez la chance de gagner de nouveaux prix.',
  },
  'leaderboard/monthly/challenge-ended/btn1': {
    en: 'Make your picks',
    fr: 'Faites Vos Choix',
  },
  'leaderboard/monthly/challenge-ended/btn2': {
    en: 'Check your stats',
    fr: 'Vérifiez Vos Statistiques',
  },
};

export default strings;
